import { render, staticRenderFns } from "./stockLnventoryTask.vue?vue&type=template&id=337fdcde&scoped=true"
import script from "./stockLnventoryTask.vue?vue&type=script&lang=js"
export * from "./stockLnventoryTask.vue?vue&type=script&lang=js"
import style0 from "./stockLnventoryTask.vue?vue&type=style&index=0&id=337fdcde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337fdcde",
  null
  
)

export default component.exports